// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_opens_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `Opens ${i.time}`
};

const el_opens_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `Ανοίγουμε ${i.time}`
};

const ru_opens_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `Открываемся ${i.time}`
};

const he_opens_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `נפתח ${i.time}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ time: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const opens_at = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.opens_at(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("opens_at", locale)
	if (locale === "en") return en_opens_at(inputs)
	if (locale === "el") return el_opens_at(inputs)
	if (locale === "ru") return ru_opens_at(inputs)
	if (locale === "he") return he_opens_at(inputs)
	return "opens_at"
};